/**
 * SVGを生成してdata:image形式で出力する
 *
 * ※通常画像はURLを指定する想定だが、テスト用の画像を生成するためのメソッド
 *
 * @param text 表示するテキスト
 * @param options オプション
 * @param options.fontSize フォントサイズ（デフォルト：24）
 * @param options.fontWeight フォントウェイト（デフォルト：'bold'）
 * @param options.strokeColor 枠線色（デフォルト：'#00af98'）
 * @param options.strokeWidth 枠線幅（デフォルト：10）
 * @param options.width SVGの幅（デフォルト：640）
 * @param options.height SVGの高さ（デフォルト：200）
 * @param options.backgroundColor 背景色（デフォルト：'#ffffff'）
 * @param options.textColor テキスト色（デフォルト：'#000000'）
 * @returns data:image形式のSVG URL
 */
export const createImageMockSource = (
  text: string,
  {
    fontSize = 24,
    fontWeight = 'bold',
    strokeColor = '#00af98',
    strokeWidth = 10,
    width = 640,
    height = 200,
    backgroundColor = '#ffffff',
    textColor = '#000000',
  }: {
    fontSize?: number;
    fontWeight?: string;
    strokeColor?: string;
    strokeWidth?: number;
    width?: number;
    height?: number;
    backgroundColor?: string;
    textColor?: string;
  } = {},
): string => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">
      <rect
        width="100%"
        height="100%"
        fill="${backgroundColor}"
        stroke="${strokeColor}"
        stroke-width="${strokeWidth}"
        rx="8"
        ry="8"
      />
      <text
        x="50%"
        y="50%"
        font-family="Arial, sans-serif"
        font-size="${fontSize}"
        font-weight="${fontWeight}"
        fill="${textColor}"
        text-anchor="middle"
        dominant-baseline="middle"
      >
        ${text}
      </text>
    </svg>
  `.trim();

  const encodedSvg = encodeURIComponent(svg);
  return `data:image/svg+xml,${encodedSvg}`;
};
